var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-button-wrapper"},[_c('v-tooltip',{attrs:{"top":"","disabled":!_vm.tooltipMessage},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var _obj;

var on = ref.on;return [_c('v-btn',_vm._g(_vm._b({staticClass:"mx-1 naj-button",class:{
          light: _vm.light,
          square: _vm.square,
          small: _vm.size === 'small',
          'x-small': _vm.size === 'x-small',
          'inputs-alignment': _vm.inputsAlignment,
          'append-icon': _vm.appendIcon
        },attrs:{"id":_vm.generateId,"data-testid":"v-btn","type":_vm.type,"color":_vm.color,"loading":_vm.loading,"to":_vm.to,"href":_vm.href,"target":_vm.target},on:{"click":_vm.clickHandler}},'v-btn',( _obj = {}, _obj[_vm.size] = !!_vm.size, _obj.text = _vm.text, _obj.outlined = _vm.outlined, _obj.disabled = _vm.disabled || _vm.loading, _obj ),false),on),[(_vm.icon)?_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._t("default")],2)]}}],null,true)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tooltipMessage)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }